import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { ActivityActions } from '../State/actions/activity.actions';
import { getActivityFetched } from '../State/selectors/activity.selector';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class ActivityResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getActivityFetched, ActivityActions.load({Payload: {}}), store);
    }
}
